import * as e from "react";
const a = (l) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...l
  },
  /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M8.008 12.25a4 4 0 003.742 3.742L8.008 12.25zm7.438 1.782a4.02 4.02 0 01-1.414 1.414l-1.514-1.514a2.004 2.004 0 001.414-1.414l1.514 1.514zm.546-2.282a4 4 0 00-3.742-3.742l3.742 3.742zM8.554 9.968l1.514 1.514a2.004 2.004 0 011.414-1.414L9.968 8.554a4.02 4.02 0 00-1.414 1.414z",
      fill: "#2d6ded"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M4.169 8.411L1.3 11.28a1 1 0 000 1.42l4.94 4.96a8 8 0 008.857 1.68l-1.56-1.561a5.999 5.999 0 01-5.88-1.531l-.002-.002-4.238-4.255 2.166-2.166-1.414-1.414zm11.269 8.441l1.427 1.427c.242-.192.474-.398.695-.62l.757-.756-1.414-1.414-.757.757h-.001a5.995 5.995 0 01-.707.606zm-6.961-9.79a6 6 0 00-.812.681v.001l-.668.667-1.414-1.414.667-.667a8 8 0 01.796-.698l1.431 1.43zm9.84 7.012l2.084-2.084-4.245-4.246h-.001a6 6 0 00-5.74-1.571L8.84 4.596a7.999 7.999 0 018.73 1.734l4.95 4.95a1 1 0 010 1.42l-2.788 2.789-1.414-1.415z",
      fill: "#2d6ded"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M3.707 5.121a1 1 0 111.414-1.414l15.557 15.556a1 1 0 01-1.415 1.415L3.708 5.12z",
      fill: "#000"
    }
  ),
  /* @__PURE__ */ e.createElement(
    "rect",
    {
      x: 3,
      y: 4.414,
      width: 2,
      height: 24,
      rx: 1,
      transform: "rotate(-45 3 4.414)",
      fill: "#2d6ded"
    }
  )
);
export {
  a as default
};
